import axios from 'axios'

export const requestVerifyCode = async (data) => await axios.post(`${process.env.REACT_APP_API}/register`, data, { timeout: process.env.REACT_APP_AXIO_TIMEOUT })

export const startVerify = async (data, code) => await axios.post(`${process.env.REACT_APP_API}/verify`, { ...data, code }, { timeout: process.env.REACT_APP_AXIO_TIMEOUT })

export const requestLogin = async (data) => await axios.post(`${process.env.REACT_APP_API}/login`, data, { timeout: process.env.REACT_APP_AXIO_TIMEOUT })